import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { useTranslate } from 'react-admin'

export const WrapperDashboard = ({ index, setList, item, id }) => {
  const translate = useTranslate()
  const onDashboardChange = (e) => {
    const newVal = e.target.value
    const setAndRestoreItem = (item) => {
      return {
        ...item,
        dashboard: newVal,
      }
    }
    setList((prev) => prev.map((item) => (item.id === id ? setAndRestoreItem(item) : item)))
  }

  return (
    <>
      <SelectInput
        source={`aplications[${index}].dashboard`}
        optionsText={['name']}
        optionValue='id'
        sx={{ width: 300 }}
        onChange={onDashboardChange}
        options={[
          { id: 'SELLER', name: translate('ra.field.seller') },
          { id: 'OPERATIONS', name: translate('ra.field.operations') },
        ]}
        label={null}
      />
    </>
  )
}
